import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { recordActions } from '../../config/configuration/react';

const useOffer = (recordId) => {
  const rId = parseInt(recordId, 10);
  const dispatch = useDispatch();
  const autobizTradeId = useSelector((state) => state.reduxRecords.data[recordId])?.record?.autobizTradeUuid;

  const getOfferRemote = async () => {
    if (autobizTradeId !== null) dispatch(recordActions.fetchCoverageOffers(rId));
  };

  useEffect(() => {
    getOfferRemote();
  }, [rId]);

  const isOfferLoading = useSelector((state) => state.reduxRecords.loading);
  const errorOfferApi = useSelector((state) => state.reduxRecords.error);
  const offers = useSelector((state) => state.reduxRecords.data[recordId]?.offers) || [];

  return { offers, isOfferLoading, errorOfferApi };
};

export default useOffer;
